import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import {
  BaseWsService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';

import { StudyEventDto } from '../../models/study-next.model';
import { StudyFacade } from '../../state/study/study.facade';
import { STUDY_TOPIC, StudyMessages } from './study.messages';

@Injectable()
export class StudyWsService extends BaseWsService {
  /**
   * The study's realtime events (contracts/study/README.md § Realtime events), as they arrive. What to
   * re-read is the consumer's call — `StudyNextStore.onStudyEvent`; this service knows the topic and the
   * wrapper, nothing about stores.
   */
  readonly #events = new Subject<StudyEventDto>();
  readonly events$ = this.#events.asObservable();

  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService,
    private studyFacade: StudyFacade
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  setTopic(studyId: string) {
    this.topic = `${STUDY_TOPIC}/${studyId}`;
  }

  protected get excludedMessagesFromLog(): string[] {
    return [StudyMessages.ProgressMessage];
  }

  handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    const payload = message.payload;
    switch (message.description) {
      case StudyMessages.LogMessage:
        this.logMessage(payload.message);
        break;
      case StudyMessages.ProgressMessage:
        this.studyFacade.updateAddBleenGroupProgress(payload.bleenGroupId, payload.progress);
        break;
      case StudyMessages.StudyEventMessage:
        this.#events.next(payload as StudyEventDto);
        break;
    }
  }
}
